import React, {Component} from 'react';
import {BASE_PATH} from "../../../../../wpconfig";
import {NavLink} from "react-router-dom";

class RJournal extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const record = this.props.record;
		return (
			<div className={record.author ? "mt-6" : "mt-4 pt-px-40 border-top border-lightgray"}>
				<div className="d-flex justify-content-between align-items-center mb-px-26">
					<div className="d-flex align-items-center">
						<h3 className="con-title">학술지</h3>
					</div>
				</div>
				<div>
					<div className="document-list-item">
						<NavLink to={BASE_PATH + "journal/?record_id=" + record.journal_id}
						         className="item-subject small font-weight-400">{record.journal_title}</NavLink>
						<div className="item-info mt-2">
							<div className="info-cell">
								<strong>권호</strong>&nbsp;&nbsp;{record.publish_year} {record.volume}{record.issue ? '(' + record.issue + ')' : ''} {record.start_page} ~ {record.end_page}
							</div>
							<div className="info-cell"><strong>출판사</strong>&nbsp;&nbsp;{record.publisher}</div>
							<div className="info-cell"><strong>문서유형</strong>&nbsp;&nbsp;{record.resource_type}</div>
							{/*<div className="info-cell"><strong>문서유형</strong>&nbsp;&nbsp;{record.resource_type}</div>*/}
						</div>
						{record.journal_impact &&
						<div className="item-info mt-1">
							<div className="" style={{position: "relative",	color: "rgba(0,0,0,0.7)"}}><strong>저널 I/F</strong>&nbsp;&nbsp;</div>
							{record.journal_impact.map((item, index) => {
								return (
									<div key={index}
									     className="info-cell">{item.indicator_type.toUpperCase()} {item.indicator_year} {item.impact ? '(' + (item.impact === 'login' ? '로그인 후 확인' : item.impact) + ')' : ''}</div>
								)
							})}
						</div>
						}
						<div className="item-info mt-1">
							<div className="info-cell"><strong>저널 Ranking</strong>
								{record.journal_ranking && record.journal_ranking.map((item, num) => {
									let className = 'mr-1 ml-1 badge bg-lightpurple rounded-0';
									if (!item.percent || !item.name)
										return;
									// item.name = item.name.toUpperCase()
									if (item.name === 'SCIE' || item.name === 'KCI')
										className = 'mr-1 ml-1 badge bg-lightgreen rounded-0';
									else if (item.name === 'Scopus')
										className = 'mr-1 ml-1 badge bg-lightorange rounded-0';
									return (
										<div key={num}
										     className={className}>{item.name} {item.year} (Top {item.percent}%)</div>
									)
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
};

export default RJournal;
